'use client';

import { useEffect, useRef } from 'react';
import { useFormStatus } from 'react-dom';

export function Enviar({ children, className = 'btn btn-primario', pendente = 'Salvando…' }: { children: React.ReactNode; className?: string; pendente?: string }) {
  const { pending } = useFormStatus();
  return (
    <button type="submit" className={className} disabled={pending}>
      {pending ? pendente : children}
    </button>
  );
}

/** Janela modal com <dialog>. Fecha sozinha quando um formulário dentro dela é enviado. */
export function Modal({
  gatilho, titulo, subtitulo, children, classeGatilho = 'btn', rotuloGatilho, abrirAoCarregar = false,
}: {
  gatilho: React.ReactNode; titulo: string; subtitulo?: string; children: React.ReactNode;
  classeGatilho?: string; rotuloGatilho?: string; abrirAoCarregar?: boolean;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (abrirAoCarregar) ref.current?.showModal();
  }, [abrirAoCarregar]);
  return (
    <>
      <button type="button" className={classeGatilho} aria-label={rotuloGatilho} onClick={() => ref.current?.showModal()}>
        {gatilho}
      </button>
      <dialog
        ref={ref}
        aria-label={titulo}
        className="m-auto w-[min(560px,calc(100vw-2rem))] rounded-2xl p-0 text-left shadow-2xl"
        onSubmit={() => setTimeout(() => ref.current?.close(), 0)}
      >
        <div className="flex items-start justify-between border-b border-slate-100 px-6 py-4">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Seekgrow · Operação</p>
            <h2 className="text-lg font-bold text-slate-900">{titulo}</h2>
            {subtitulo && <p className="text-xs text-slate-500">{subtitulo}</p>}
          </div>
          <button type="button" className="btn-icone" aria-label="Fechar" onClick={() => ref.current?.close()}>✕</button>
        </div>
        <div className="max-h-[75vh] overflow-y-auto px-6 py-5">{children}</div>
      </dialog>
    </>
  );
}

/** Select que envia o formulário de filtros assim que muda. */
export function SelectAuto(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} onChange={(e) => e.currentTarget.form?.requestSubmit()} />;
}
